import { Badge } from '@simplywallst/ui-core/next';
import { formatDistanceToNow, differenceInHours } from 'date-fns';

type Props = {
  updatedAt: string | null | undefined;
  narrativeWillLockAt: string | null | undefined;
  updateWillLockAt: string | null | undefined;
};

export const NarrativeCardTimeBadge = ({
  updatedAt,
  narrativeWillLockAt,
  updateWillLockAt,
}: Props) => {
  const narrativeWillLockAtDate = narrativeWillLockAt
    ? new Date(narrativeWillLockAt)
    : null;
  const updateWillLockAtDate = updateWillLockAt
    ? new Date(updateWillLockAt)
    : null;

  const updatedDate = updatedAt ? new Date(updatedAt) : null;

  const hasFreshUpdate =
    updateWillLockAtDate &&
    narrativeWillLockAtDate &&
    updateWillLockAtDate > narrativeWillLockAtDate &&
    differenceInHours(new Date(), updateWillLockAtDate) < 24;

  if (hasFreshUpdate)
    return (
      <div className="grid justify-end">
        <Badge tone="attention">Updated</Badge>
        <span className="sr-only"> narrative</span>
      </div>
    );

  const isNew =
    narrativeWillLockAtDate &&
    differenceInHours(new Date(), narrativeWillLockAtDate) < 24;

  if (isNew)
    return (
      <div className="grid justify-end">
        <Badge tone="attention">New</Badge>
        <span className="sr-only"> narrative</span>
      </div>
    );

  if (!updatedDate) return null;

  return (
    <div className="grid min-h-x3 justify-end text-xs text-softer">
      {formatDistanceToNow(updatedDate, {
        addSuffix: true,
      })}
      <span className="sr-only"> author updated this narrative</span>
    </div>
  );
};
